import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DxTooltipModule } from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'al-tabs',
	templateUrl: 'al-tabs.component.html',
	styleUrls: ['al-tabs.component.scss'],
	standalone: true,
	imports: [NgIf, DxTooltipModule, DxTemplateModule, AsyncPipe],
})
export class ALTabsComponent {
	// selected tab subject; can be supplied from without so propagation is unnecessary
	@Input()
	selectedTab$ = new BehaviorSubject(1);

	@Input()
	tabInfo: any[];

	// method for tab click event... can be overriden through input
	@Input()
	onTabClick = tab => this.selectedTab$.next(tab.id);

	onTabClicked(tab) {
		if (!tab.disabled) {
			this.onTabClick(tab);
		}
	}

	getTabClass(tab, selectedTab: number) {
		if (tab.disabled) {
			return 'tab-disabled';
		} else if (selectedTab === tab.id) {
			return 'tab-selected';
		}
		return '';
	}
}
